<template>
  <div>
    <modals-container name="modal" />
    <v-dialog/>
    <div class="admin_title">小组管理</div>
    <!--左侧内容-->
    <div class="col_2_1 w240" v-if="treemenu && treemenu.length > 0">
      <TreeView :model="treemenu" @node-clicked="nodeClicked" :options="options"></TreeView>
    </div>
    <div class="col_2_1 w240" v-else>
      <img src="@/assets/images/none_data.jpg">
    </div>
    <!--/左侧内容-->
    <!--右侧内容-->
    <div class="col_2_2 w705 gj_right structure_org_stretch" v-if="panel == '0'">
      <div class="top_gj_r"><label v-if="dept && dept.name">{{dept.name}}</label><label v-if="!dept.name">请在左侧菜单中选择部门</label><span><a @click="switchPanel('2');formdept = {};" style="cursor: pointer;">新增小组</a><!--a @click="delDeptBox()" style="cursor: pointer;">删除部门</a--></span></div>
      <div class="top_gj_btn">
        <a @click="delUsers(selected)">批量删除</a>
        <!--select name="">
          <option>批量导入/导出</option>
          <option>批量导入</option>
          <option>批量导出</option>
          批量导入/导出
        </select-->
        <!--a href="">设置所在部门</a--></div>
      <div class="gj_list" v-if="panel == '0'" style="min-height: 450px;">
        <BylTable :model="tableData" @table-selected="updateSelected" v-if="tableData.data.length > 0"></BylTable>
        <h5 class="none_ts" v-if="tableData.data.length == '0'">
          <img src="@/assets/images/none_data.jpg" alt="">
        </h5>
      </div>
      <div class="zy_list_bottom mtf30">
        <dl>
          <dt v-if="pages > 0">共{{cnt}}个人员</dt>
          <dd>
            <paginate v-if="pages > 0" :click-handler="clickCallback" :page-count=pages
                      :container-class=$global.paginationOptions.container_class :page-class=$global.paginationOptions.page_class :page-link-class=$global.paginationOptions.page_link_class
                      :prev-class=$global.paginationOptions.prev_class :prev-link-class=$global.paginationOptions.prev_link_class
                      :next-class=$global.paginationOptions.next_class :next-link-class=$global.paginationOptions.next_link_class
                      :first-last-button=$global.paginationOptions.first_last_button
                      :active-class=$global.paginationOptions.active_class
                      :disabled-class=$global.paginationOptions.disabled_class
                      :first-button-text=$global.paginationOptions.first_button_text
                      :last-button-text=$global.paginationOptions.last_button_text
                      :prev-text=$global.paginationOptions.prev_text
                      :next-text=$global.paginationOptions.next_text></paginate>
          </dd>
        </dl>
      </div>
    </div>
    <div class="col_2_2 w705 gj_right structure_org_stretch" v-if="panel == '1'">
      <div class="add_man_tit"><span v-if="JSON.stringify(formperson) == '{}'">新增</span><span v-else>编辑</span>人员</div>
      <div class="add_con_man">
        <Person @saved="getDataPF" @closed="panel = '0'" :data="formperson"></Person>
      </div>
    </div>
    <div class="col_2_2 w705 gj_right structure_org_stretch" v-if="panel == '2'">
      <div class="add_man_tit"><span v-if="JSON.stringify(formdept) == '{}'">新增</span><span v-else>编辑</span>小组</div>
      <div class="add_con_man">
        <Group @saved="getDataFF" @closed="panel = '0'" :data="formdept"></Group>
      </div>
    </div>
    <!--/右侧内容-->
    <div class="clear"></div>
  </div>
</template>
<script>
  import api from '@/api/index'
  import config from '@/config/index'

  import TreeSelect from '@/page/byl/sys/menu/treemenu.vue'
  import TreeView  from '@/components/common/treeview/index.vue'
  import BylTable from '@/components/common/table/index.vue'
  import Group from '@/page/byl/org/group/group.vue'
  import Person from '@/page/byl/org/group/person.vue'
  import Paginate from 'vuejs-paginate'
  import difference from 'lodash.differenceby'
  import utils from '@/utils'
  import { mapState, mapActions, mapGetters } from 'vuex'
  export default {
    components: { TreeView, BylTable, Group, Person, Paginate },
    data () {
      var that = this
      return {
        pages: 0,
        options: {
          parentNodeClickable: true, //  点击有子菜单的node是否可以发出事件
          multiselect: false, // 是否允许多选
          searchMode: true, // 是否提供过滤
          editMode: true,
          del: function (val) {
            that.confirmBox({
              title: '删除',
              text: '确认删除' + val.name + '吗?',
              yes: function () {
                that.$modal.hide('dialog')
                that.delDept(val.id)
              }
            })
          },
          edit: function (val) {
            that.panel = '2'
            api.get(config.bylApiPath, '/group/' + val.id, null, function (r) { // 提交正常
              that.formdept = r.data
            })
          }
        },
        tableData: {
          columns: [
            {
              field: 'name',
              title: '姓名',
              colWidth: 82
            }, {
              field: 'post',
              title: '职务',
              colWidth: 122
            }, {
              field: 'idCard',
              title: '身份证号',
              colWidth: 150
            }
          ],
          data: []
        },
        cnt: 0,
        treemenu: [],
        formperson: {},
        formdept: {},
        panel: '0', // '0': 列表; '1': 添加成员; '2': 添加部门
        selected: [], // 选择的列表
        createUserType: '1' // 创建用户账号类型
      }
    },
    created () {
      this.getDepts() // 异步获取小组信息
    },
    mounted () {
    },
    watch: {
      getCurrentDepts (val) { // 异步获取到的所有部门数据需要用watch
        this.treemenu = val
        // this.$set(this, 'treemenu', val) // 对象新增属性需要这么写
      },
      getCurrentList (val) { // 异步获取到的所有部门下面的人员数据需要用watch
        this.tableData.data = val
      }
    },
    computed: {
      ...mapState('orgroup', ['menus', 'dept', 'list']),
      ...mapGetters('orgroup', ['getCurrentList', 'getCurrentDepts', 'getCurrentDept'])
    },
    methods: {
      ...mapActions('orgroup', ['getDepts', 'addDept', 'delDept', 'getPersonByDept', 'setDept', 'addPerson']),
      updateSelected (val) {
        this.selected = val
      },
      clickCallback (pageNum)  {
        console.log(pageNum)
      },
      switchPanel (panel) {
        this.panel = panel;
        this.$modal.hide();
      },
      edit (item) {
        var that = this
        this.panel = '1'
        api.get(config.bylApiPath, '/member/' + item.id, null, function (r) {
          that.formperson = r.data[0]
        })
      },
      confirmBox (o) {
        var that = this
        this.$modal.show('dialog', {
          title: o.title,
          text: o.text,
          buttons: [
            {
              title: '确认',
              default: true,
              handler: utils.debounce(() => {
                if (o.yes && o.yes instanceof Function) {
                  o.yes()
                  that.$modal.hide('dialog') // !!!必须清掉模态框，否则在别的页面按enter键会触发方法的
                }
              }, 1000)
            },
            {
              title: '取消'
            }
          ]
        })
      },
      delUsers (items) {
        if (items.length > 0) {
          var that = this
          this.confirmBox({
            title: '删除',
            text: '确认删除吗?',
            yes: function () {
              var l = difference(that.tableData.data, items, 'id')  // 求差集
              api.post(config.bylApiPath, '/group/add', {id: that.getCurrentDept.id, groupMembers: l, name: that.getCurrentDept.name}, function (r) { // 正常
                that.$toasted.show('删除成功')
                setTimeout(function () {
                  that.getPersonByDept(that.getCurrentDept.id)
                }, 0)
                that.$modal.hide('dialog')
              })
            }
          })
        } else {
          this.$toasted.show('没有删除项')
        }
      },
      createUsers (items) {
        console.log(items)
      },
      createUser (item) {
        if (item) {
          var that = this
          this.confirmBox({
            title: '生成用户',
            text: '请选择账号类型: <select id="createUserType" class="all_select"><option value="1">手机号</option><option value="2">邮箱</option><option value="3">身份证</option><option value="4">工号</option></select>',
            yes: function () {
              var o = {
                accountType: $('#createUserType').val(),
                memberId: item.id
              }
              api.post(config.bylApiPath, '/member/batch/create/user', {registerList: [o]}, function (r) { // 正常
                that.$toasted.show('创建账户成功')
                setTimeout(function () {
                  that.getPersonByDept(that.getCurrentDept.id)
                }, 0)
                that.$modal.hide('dialog')
              })
            }
          })
        }
      },
      del (item) {
        if (item) {
          var that = this
          this.confirmBox({
            title: '删除',
            text: '确认删除吗?',
            yes: function () {
              api.get(config.bylApiPath, '/member/delete/batch', {ids: item.id}, function (r) { // 正常
                that.$toasted.show('删除成功')
                setTimeout(function () {
                  that.getPersonByDept(that.getCurrentDept.id)
                }, 0)
                that.$modal.hide('dialog')
              })
            }
          })
        }
      },
      nodeClicked (node) { // 获取部门下面的人员
        this.setDept(node)
        this.getPersonByDept(node.id)
      },
      getDataFF (data) {
        var that = this
        var p = {
          name: data.name
        }
        if (data && data.list && data.list.length > 0) {
          var r = []
          for (let i = 0; i < data.list.length; i++) {
            var o = data.list[i]
            var a = {
              memberId: o.id
            }
            r.push(a)
          }
        }
        p.groupMembers = r
        this.addDept(p)
        setTimeout(function () {
          that.getDepts()
        }, 1000)
      },
      getDataPF (data) {
        var that = this
        var deptId = data.parent.id
        if (data.parent) { delete data.parent }
        this.addPerson(data)
        setTimeout(function () {
          that.getPersonByDept(deptId)
        }, 1000)
      }
    }
  }
</script>
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/page/byl/org/group/index.vue